import React, { useState, useEffect } from 'react';
import { MDBRow, MDBTable } from 'mdb-react-ui-kit';
import TableHeader from '../../../components/table/TableHeader';
import TableBody from '../../../components/table/TableBody';
import RoundSelector from '../round-selector/RoundSelector';
import MusUtils from '../../../utils/Utilities';
import './DetallesPartidaPage.scss';

export default function DetallesPartidaPage({torneoEnCurso, onChange, setAllowedContinue}: any) {
  const [torneo, setTorneo] = useState(torneoEnCurso);
  const [roundNum, setRoundNum] = useState(0);
  const [possibleCombinationsLog, setPossibleCombinationsLog] = useState();
 
  let theme = MusUtils.getTheme();
  let darkgrayBackground = 'darkgray';
  let lightgrayBackground = 'lightgray';
  if (theme === 'dark') {
    darkgrayBackground = '#1d2b4d';
    lightgrayBackground = '#274a82';
    // lightgrayBackground = '#ligthgray';
  }

  useEffect(() => {
    setTorneo(torneoEnCurso);
    setRoundNum(torneoEnCurso.roundNum ? torneoEnCurso.roundNum : 0);
    let result = MusUtils.string_decompress(localStorage.getItem("mus-possibleCombinationsLog"));
    if (result===null) {
      result="";
    } else {
      result = result.replace(/\n/g, '<br>');
    }
    setPossibleCombinationsLog(result);
  },[torneoEnCurso]);

  const onRoundChange = num => {
    setRoundNum(num)
  }

  const getBackground = (column, player1, player2) => {
    return (column === "Pareja") ? darkgrayBackground :
        (player1.id === player2.id || player1.status === "Eliminado" || player2.status === "Eliminado") ?  lightgrayBackground :
        MusUtils.getNumberConfontrations(torneo, player1, player2) === 0 ? "white" : 
        MusUtils.getNumberConfontrations(torneo, player1, player2) === 1 ? "yellow" :
        MusUtils.getNumberConfontrations(torneo, player1, player2) === 2 ? "orange" : 
        MusUtils.getNumberConfontrations(torneo, player1, player2) === 3 ? "aqua" : 
        MusUtils.getNumberConfontrations(torneo, player1, player2) === 4 ? "blue" : "red"
  }

  const getStyles = (column, player1, player2) => {
    return {
      fontWeight: column==="Pareja" ? '600' : 'inherit',
      color: column==="Pareja" && theme==="dark" ? "white" : "inherit" ,
      background: getBackground(column, player1, player2)
    }
  }

  return (
    torneo && torneo.doublets ? <>
      <div>
        <MDBRow>
          <div className='d-flex justify-content-start p-3 col-12'>
            <RoundSelector torneo={torneo} onRoundChange={onRoundChange} roundNumSelected={roundNum}/>
          </div>
        </MDBRow>
        <div style={{maxWidth:'100vw'}}>
          <div style={{overflow: 'auto', position: 'relative'}}>
            <MDBTable align='middle'>
              <TableHeader light>
                <tr>
                  <th style={{maxWidth:'130px', zIndex:'99'}} className='sticky-col-row1'>Pareja</th>
                    {
                      torneo.doublets.map((item, index) => {
                        return (
                          <th style={{minWidth:'30px', height: '200px'}}>
                            <div style={{transform: "rotate(90deg)", width:'30px', position: 'relative', top: '-150px'}}>{item.nameDoublet}</div>
                          </th>
                        )
                      })
                    }
                </tr>
              </TableHeader>
              <TableBody>
                {torneo.doublets?.map((player1, indexPlayer1) => {
                  return (
                    <tr>
                      <td className='sticky-col-row2' style={getStyles('Pareja')} >
                        {player1.nameDoublet}
                      </td> 
                      {torneo.doublets?.map((player2, indexPlayer2) => {
                        return (
                          <td className='text-center' style={getStyles('', player1, player2)}>
                            {MusUtils.getNumberConfontrations(torneo, player1, player2)}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
                {/* })} */}
              </TableBody>
            </MDBTable>
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: possibleCombinationsLog }}/>
      </div>
    </> : <div>"PENDING SAVE MATCH GENERATED BY ELIMINATORY PROPERLY ON DEFINED STRUCTURE"</div>
  );
}
